import { FunctionComponent } from 'preact';
import { useRef, useEffect } from 'preact/hooks';
import { useTranslation } from 'react-i18next';
import {
  CloseButtonContainer,
  CrossIcon,
  HeaderContainer,
} from './Header.styles';

interface HeaderProps {
  onClose?: () => void;
  closable?: boolean;
  id?: string;
}

const Header: FunctionComponent<HeaderProps> = ({
  onClose,
  children,
  closable = true,
  id,
}) => {
  const { t } = useTranslation();
  const closeButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (closeButtonRef.current && closable) {
      closeButtonRef.current.focus();
    }
  }, [closable]);

  return (
    <HeaderContainer data-testid="modal-header-container" id={id}>
      {children}
      <CloseButtonContainer
        data-testid="modal-close-button"
        ref={closeButtonRef}
        closable={closable}
        onClick={onClose}
        aria-label={t('ALT_TEXT_CLOSE_MODAL')}
        aria-labelledby={id}
        type="button"
      >
        <CrossIcon aria-hidden />
      </CloseButtonContainer>
    </HeaderContainer>
  );
};

export default Header;
